import { createFileRoute, redirect } from '@tanstack/react-router';

import { StripeCheckoutGate } from '@/components/settings/billing/stripe-checkout-gate';
import { billingPageOpens } from '@/lib/billing/app-store-access';
import { canShowPurchaseFlow } from '@/lib/native/purchase-visibility';
import Page from '@/screens/settings/billing/checkout/page';

/** The checkout, guarded again once the profile is in (a reload has none in beforeLoad). */
function CheckoutRoute() {
  return (
    <StripeCheckoutGate>
      <Page />
    </StripeCheckoutGate>
  );
}

export const Route = createFileRoute('/_app/settings/billing/checkout/')({
  beforeLoad: () => {
    // No Stripe purchase inside the native shells, nor while the workspace
    // pays through the App Store — see purchase-visibility. Where the billing
    // page opens, it says why: it shows the App Store subscription.
    if (!canShowPurchaseFlow()) {
      throw redirect({ to: billingPageOpens() ? '/settings/billing' : '/settings/personal' });
    }
  },
  component: CheckoutRoute,
});
